package com.klantenstop.web.pages.authentication.verifyEmail

import com.klantenstop.web.data.models.domain.VerificationStatus
import com.klantenstop.web.data.repos.UserRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class VerifyEmailViewModel(
    code: String,
    private val userRepo: UserRepo = UserRepo
) : ViewModel(), VerifyEmailContract {

    private val _state = MutableStateFlow(VerifyEmailContract.State(code))
    override val state = _state.asStateFlow()

    private val _effect = MutableSharedFlow<VerifyEmailContract.Effect>()
    override val effect = _effect.asSharedFlow()

    init {
        sendIntent(VerifyEmailContract.Intent.VerifyCode)
    }

    override fun sendIntent(intent: VerifyEmailContract.Intent) = coroutineScope.launch {
        when (intent) {
            is VerifyEmailContract.Intent.VerifyCode -> verifyCode()
            is VerifyEmailContract.Intent.ResendVerification -> resendVerification()
            is VerifyEmailContract.Intent.NavigateToHome -> emitEffect(VerifyEmailContract.Effect.NavigateToHome)
        }
    }

    private suspend fun verifyCode() {
        val code = state.value.code
        val status = userRepo.verifyEmail(code)

        updateState { it.copy(verificationStatus = status) }
    }

    private suspend fun resendVerification() {
        try {
            val status = userRepo.resendVerificationEmail()
            updateState { it.copy(verificationStatus = status) }
        } catch (e: Exception) {
            val status = VerificationStatus.Error(e.message ?: "Er is een fout opgetreden bij het verzenden van de verificatie-e-mail")
            updateState { it.copy(verificationStatus = status) }
        }
    }

    override fun emitEffect(effect: VerifyEmailContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (VerifyEmailContract.State) -> VerifyEmailContract.State) {
        _state.update(block)
    }
}
